import React from 'react'
import Flex from '../Flex'
import Text from '../Text'
import { TextAreaProps } from './Input.types'
import { StyledTextArea } from './styled'

const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
  (
    { label, hint, isError, error, showCount, maxLength, value, onChange, rows = 4, ...restProps },
    ref,
  ) => {
    const renderErrorText = () => {
      if (isError) {
        if (showCount && maxLength) {
          return (
            <Flex width='100%' justifyContent='space-between'>
              <Text variant='caption' color='red50' aria-label='input-error'>
                {error}
              </Text>
              <Text
                variant='caption'
                color='red50'
                aria-label='input-count'
              >{`${value.length}/${maxLength}`}</Text>
            </Flex>
          )
        }
        return (
          <Text variant='caption' color='red50' aria-label='input-error'>
            {error}
          </Text>
        )
      }
      if (hint) {
        if (showCount && maxLength) {
          return (
            <Flex width='100%' justifyContent='space-between'>
              <Text variant='caption' color='black50' aria-label='input-hint'>
                {hint}
              </Text>
              <Text
                variant='caption'
                color='black50'
                aria-label='input-count'
              >{`${value.length}/${maxLength}`}</Text>
            </Flex>
          )
        }
        return (
          <Text variant='caption' color='black50' aria-label='input-hint'>
            {hint}
          </Text>
        )
      }
      if (showCount && maxLength) {
        return (
          <Flex width='100%' justifyContent='flex-end'>
            <Text
              color='black50'
              variant='caption'
              aria-label='input-count'
            >{`${value.length}/${maxLength}`}</Text>
          </Flex>
        )
      }
    }

    const handleOnChange = (event: React.FormEvent<HTMLTextAreaElement>) => {
      if (maxLength) {
        if (event.currentTarget.value.length <= maxLength) {
          return onChange(event)
        }
        const value = event.currentTarget.value
        event.currentTarget.value = value.substring(0, maxLength)
        return onChange(event)
      } else {
        return onChange(event)
      }
    }

    return (
      <Flex flexDirection='column' rowGap='8px' width='100%'>
        {label && (
          <Text variant='caption' weight='bold' color='black50' aria-label='input-label'>
            {label}
          </Text>
        )}
        <StyledTextArea
          onChange={handleOnChange}
          isError={isError}
          aria-label='text-area-input'
          placeholder='placeholder'
          value={value}
          ref={ref}
          rows={rows}
          {...restProps}
        />
        {renderErrorText()}
      </Flex>
    )
  },
)

export default TextArea
